import React, { useMemo } from 'react'
import { TextFilterProps } from '@progress/kendo-react-data-tools'
import { useAppSelector } from 'store'

import { MultiSelectFilter } from '../MultiSelectFilter'

export const TicketStatusFilter: React.FC<TextFilterProps> = (props) => {
  const { filter, onFilterChange } = props
  const ticketStatuses = useAppSelector((state) => state.tickets.statuses)
  const data = useMemo(
    () => ticketStatuses.map((x) => ({ id: x.id, label: x.name, value: x.id })),
    [ticketStatuses]
  )

  return (
    <MultiSelectFilter
      placeholder='Statuses'
      filter={filter}
      onFilterChange={onFilterChange}
      data={data}
    />
  )
}
